
export class Qualification {
  id: number;
  code: string;
  intitule: string;

  constructor({
    id = null,
    code = '',
    intitule = '',
  }) {
    this.id = id;
    this.code = code;
    this.intitule = intitule;
  }
}


